import { useFormikContext } from 'formik';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Input from 'components/shared/Input/Input';

const DBAName = ({ practice, setPractice }) => {
  const { setFieldValue, errors } = useFormikContext();

  const handleChange = (e) => {
    setFieldValue('dbaName', e?.target?.value);
    setPractice((prev) => ({ ...prev, dba_name: e?.target?.value }));
  };

  return (
    <div className="flex w-full flex-col justify-between gap-5 border-b border-l-0 border-r-0 border-t-0 border-solid border-b-neutral-100 py-5">
      <div className="flex gap-5 text-sm">
        <span className="font-500">Practice Name</span>
      </div>
      <div className="grid w-full grid-cols-2 gap-5">
        <div className="w-full">
          <Input
            label="Legal Name"
            placeholder="Legal Name"
            type="text"
            name="legal_name"
            value={practice?.name}
            disabled
          />
        </div>
        <div className="w-full">
          <Input
            label="DBA Name"
            type="text"
            placeholder="DBA Name"
            name="dba_name"
            value={practice?.dba_name}
            onChange={(e) => handleChange(e)}
            error={errors?.dbaName}
            tooltip="The 'Doing Business As' (DBA) name entered here will be used in all patient communications, including appointment reminders and billing notices. If left blank, communications will default to the legal name of the practice. Use a DBA name that patients easily recognize to enhance clarity and branding in your interactions."
          />
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(DBAName);
